var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHungary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.8654C0.352063 12.5988 0 14.4735 0 16.4306C0 18.3877 0.352063 20.2626 0.995188 21.9958L16 23.3871L31.0048 21.9958C31.6479 20.2626 32 18.3877 32 16.4306C32 14.4735 31.6479 12.5988 31.0048 10.8654L16 9.47412L0.995188 10.8654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.430664C9.12062 0.430664 3.25587 4.77266 0.995247 10.8655H31.0049C28.7441 4.77266 22.8795 0.430664 16 0.430664Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4309C22.8795 32.4309 28.7441 28.0889 31.0049 21.9961H0.995247C3.25587 28.0889 9.12062 32.4309 16 32.4309Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHungary);
export default __webpack_public_path__ + "static/media/flag_hungary.ba2e5d5d567a6553c89d0d2cceb5580e.svg";
export { ForwardRef as ReactComponent };